import { Navigate } from "@tanstack/react-router";

export function ActivityAdminPage() {
  return <Navigate to="/activities/admin/catalogue" />;
}
